// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__HqI+k","container":"styles_container__bZCZ9","bannerContent":"styles_bannerContent__H8KKX","backgroundImage":"styles_backgroundImage__jBaiG"};